import React from "react";
import EngagementVideoPage from "../../ui/EngagementVideoPage";

const FoodDistribution = () => (
  <EngagementVideoPage
    title="Food Distribution"
    videoUrl="https://www.youtube.com/embed/DQdHnOwMDQM"
    videoTitle="Food Distribution"
  >
    <p>
      Kindness engagements were started with the sole aim of sharing our privileges with the downtrodden, along with creating a snowball effect of kindness that&apos;ll eventually help us in our mission of having people perpetually initiate acts of kindness.
      <br />
      Therefore, with this very idea in mind, we decided to spend World Kindness Day &apos;18, with the future of our nation- the children.
    </p>
    <p>
      KU in association with Schbang & Roti Bank, celebrated World Kindness Day- 2018, with 20,000...yes, 20,000 children across BMC schools, Mumbai (India).
    </p>
    <p>
      We distributed 20,000 edible gifts of kindness to the children with the hope that the kindness bug hits them soon! We played, we laughed, we danced & made interesting conversations around practising kindness.
      <br />
      After all, the motive was never to distribute food alone but to make the lil&apos; ones experience the true joy of being kind.
    </p>
  </EngagementVideoPage>
);

export default FoodDistribution;
